// Réclamations (H7-03, M22) : dépôt par l'usager (catégorie, description, pièces du coffre, objet lié
// facultatif, indicateur sensible), affectation, marquage sensible, réponse visible par l'usager,
// clôture, évaluation (note de 1 à 5 et commentaire). Échéance par défaut : 15 jours ouvrés.
import { z } from 'zod';
import { schemaCodeCollectivite } from './usagers-comptes';

const uuid = z.string().uuid('Identifiant invalide');

export const CATEGORIES_RECLAMATION = {
  accueil: 'Accueil et information',
  delai: 'Délai de traitement',
  qualite_service: 'Qualité du service rendu',
  proprete: 'Propreté et salubrité',
  voirie: 'Voirie et équipements',
  comportement_agent: 'Comportement d\'un agent',
  corruption_alleguee: 'Corruption alléguée',
  donnees_personnelles: 'Données personnelles',
  autre: 'Autre',
} as const;
export type CategorieReclamation = keyof typeof CATEGORIES_RECLAMATION;

/** Catégories toujours traitées comme sensibles (atteinte à une personne, corruption alléguée, données personnelles). */
export const CATEGORIES_SENSIBLES: CategorieReclamation[] = ['comportement_agent', 'corruption_alleguee', 'donnees_personnelles'];

export const ETATS_RECLAMATION = ['recue', 'en_instruction', 'repondue', 'cloturee'] as const;
export const DELAI_REPONSE_RECLAMATION_JOURS = 15;

export const schemaCreationReclamation = z
  .strictObject({
    collectivite: schemaCodeCollectivite,
    categorie: z.enum(Object.keys(CATEGORIES_RECLAMATION) as [CategorieReclamation, ...CategorieReclamation[]]),
    description: z.string().trim().min(3).max(10000),
    objet_lie_type: z.enum(['dossier', 'service', 'rendez_vous']).optional(),
    objet_lie_id: uuid.optional(),
    sensible: z.boolean().default(false),
    pieces_coffre: z.array(z.strictObject({ piece_id: uuid })).max(10).default([]),
  })
  .refine((v) => (v.objet_lie_type === undefined) === (v.objet_lie_id === undefined), { message: 'Type et identifiant de l\'objet lié vont ensemble', path: ['objet_lie_id'] });

export const schemaAffectationReclamation = z
  .strictObject({ service_id: uuid.optional(), appartenance_id: uuid.optional() })
  .refine((v) => v.service_id || v.appartenance_id, { message: 'Indiquer un service ou un agent', path: ['service_id'] });
export const schemaMarquageSensible = z.strictObject({ motif: z.string().trim().min(3).max(500) });
export const schemaReponseReclamation = z.strictObject({ reponse: z.string().trim().min(3).max(5000) });
export const schemaClotureReclamation = z.strictObject({ motif: z.string().trim().max(500).optional() });
export const schemaEvaluationReclamation = z.strictObject({ note: z.number().int().min(1).max(5), commentaire: z.string().trim().max(2000).optional() });
export const schemaFiltreReclamations = z.object({
  etat: z.enum(ETATS_RECLAMATION).optional(),
  service: uuid.optional(),
  sensible: z.enum(['oui', 'non']).optional(),
  en_retard: z.enum(['oui', 'non']).optional(),
});
